import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { queryStatusFor } from '../utils/contentMode';
import UseEditorContentModeValueQuery, {
	type useEditorContentModeValueQuery$data,
	type useEditorContentModeValueQuery$variables,
} from '../hooks/__generated__/useEditorContentModeValueQuery.graphql';

export const preloadContentMode = ({
	contentId,
	isDraft,
	useCache = false,
	isArchived,
}: {
	contentId: useEditorContentModeValueQuery$variables['contentId'];
	isDraft: useEditorContentModeValueQuery$variables['isDraft'];
	useCache: boolean;
	isArchived?: boolean;
}) => {
	const status = queryStatusFor(isDraft, isArchived);

	return query<useEditorContentModeValueQuery$data, useEditorContentModeValueQuery$variables>({
		query: UseEditorContentModeValueQuery,
		variables: {
			contentId,
			isDraft,
			status: [status],
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
};
